export const disableActionsByDefaultModal = (columnId: string) => {
  return (
    columnId === 'empresa-codigo-id' ||
    columnId === 'empresa-nome-id' ||
    columnId === 'produto-codigo-id' ||
    columnId === 'produto-material-id' ||
    columnId === 'cd-loja-codigo-id' ||
    columnId === 'cd-loja-nome-id' ||
    columnId === 'ruptura-one-day-id' ||
    columnId === 'ruptura-ten-days-id'
  )
}
